import React, { type ReactElement } from 'react';
import { CameraAreaPageMap } from '../Map/PageMaps';
import { Camera, type CameraOverviewProps, type ICameraOverviewState } from './Cameras.types';
import { NearbyCameras } from './NearbyCameras';

import type { LeafletEvent } from 'leaflet';
import type { LayerSetupDefinition } from '../Map/Map.types';

export class CameraOverview extends React.Component<CameraOverviewProps, ICameraOverviewState> {
    private presentCameras: Camera[];
    layers: { [key: string]: LayerSetupDefinition };

    constructor(props: CameraOverviewProps) {
        super(props);
        this.presentCameras = this.getInitialCameras();

        this.state = {
            visibleCameras: this.presentCameras,
            showMap: false,
        };
    }

    componentDidMount(): void {
        if (this.props.favoritesPage) {
            const favorites = this.getFavoriteCamerasIds();
            favorites.forEach((cameraId) => {
                const match = this.props.cameras.find((c) => Number(c.pageId) === cameraId);
                if (match) {
                    match.isFavorite = true;
                    this.presentCameras.push(match);
                }
            }, []);
        }

        this.setState({
            visibleCameras: this.presentCameras,
            showMap: true,
        });
    }

    private onMapZoom = (e: LeafletEvent) => {
        if (this.props.favoritesPage) {
            return;
        }

        const bounds = e.target.getBounds();

        this.setState({
            visibleCameras: this.presentCameras.filter((camera) => {
                return bounds.contains(camera.wgs84Position.coordinates.slice().reverse());
            }),
        });
    };

    private getInitialCameras(): Camera[] {
        if (this.props.favoritesPage) {
            return [];
        }

        if (this.props.currentArea !== undefined) {
            return this.props.cameras.filter((c: Camera) => {
                return c.area === this.props.currentArea;
            });
        }

        if (this.props.currentRoad !== undefined) {
            return this.props.cameras.filter((c: Camera) => {
                return c.road === this.props.currentRoad;
            });
        }

        return this.props.cameras;
    }

    private getFavoriteCamerasIds(): number[] {
        const key = 'MyCameraPages' + this.props.region.toUpperCase();
        const ids = localStorage[key] ? (JSON.parse(localStorage[key]) as string[]) : [];

        return ids.reduce((total, current) => {
            const id = Number(current);

            if (!isNaN(id) && id !== 0) {
                total.push(id);
            }
            return total;
        }, []);
    }

    private renderCameras() {
        return (
            <>
                <div className="map-container mb-4">
                    {this.state.showMap && (
                        <CameraAreaPageMap
                            mapSettings={this.props.mapSettings}
                            onMapZoom={this.onMapZoom}
                            pageId={this.props.pageId}
                            areaCameras={this.presentCameras}
                        />
                    )}
                </div>
                <NearbyCameras {...this.props} animateTiles={this.state.visibleCameras?.length < 50} cameras={this.state.visibleCameras} />
            </>
        );
    }

    private renderChooseCamerasText() {
        return (
            <div className="row lead mb-4">
                <div className="col missing-favorite-cameras-text">{this.props.missingFavoriteCameraText}</div>
            </div>
        );
    }

    render(): ReactElement {
        return <>{!this.props.favoritesPage || this.state.visibleCameras.length > 0 ? this.renderCameras() : this.renderChooseCamerasText()}</>;
    }
}
